(function () {
  angular
    .module('app.core.invites')
    .constant('INVITATION_CACHE', {
      CODE: 'CACHED_INVITATION_CODE',
    })
    .constant('INVITATION_TYPE', {
      RESELLER_ENROLLEE_INVITE: {
        forwardable: true,
      },
      RESELLER_MEMBER_INVITE: {
        forwardable: false,
      },
    });
})();
